import imageClientAPI from "image-client-api/dist/imageClientSDK.js";
import { toPixelCrop } from "./image-crop.js";
const getCroppedImage = ({
  mediaId,
  sourceWidth,
  sourceHeight,
  crop
}) => {
  const pixelCrop = toPixelCrop({ crop, sourceWidth, sourceHeight });
  if (!mediaId || !sourceWidth || !sourceHeight || !pixelCrop) {
    return;
  }
  return {
    url: imageClientAPI.getCropImageURL(
      mediaId,
      sourceWidth,
      sourceHeight,
      pixelCrop.x,
      pixelCrop.y,
      pixelCrop.width,
      pixelCrop.height,
      pixelCrop.width,
      pixelCrop.height
    ),
    width: pixelCrop.width,
    height: pixelCrop.height
  };
};
export {
  getCroppedImage
};
//# sourceMappingURL=get-cropped-image.js.map
